import React, { useEffect, useState } from "react";
import Layout from "../../../HOC/layout/Layout";
import LeftDashboardSection from "../../PageComponent/DashBoardDetails/LeftDashboardSection/LeftDashboardSection";
import RightDashboardSection from "../../PageComponent/DashBoardDetails/RightDashboardSection/RightDashboardSection";
import ContextApi from "../../../HOC/ContextsAPI/ContextApi";
import axios from "../../../HOC/CreateAxios/CreateAxios";

function DashBoard() {
  // const [bookingData, setBookingData] = useState([
  //   { token: "1", price: "200", status: "rejected" },
  //   { token: "2", price: "200", status: "accepted" },
  //   { token: "3", price: "200", status: "completed" },
  //   { token: "4", price: "200", status: "accepted" },
  //   { token: "5", price: "200", status: "rejected" },
  //   { token: "6", price: "200", status: "pending" },
  //   { token: "7", price: "200", status: "completed" },
  //   { token: "8", price: "200", status: "accepted" },
  // ]);
  const [bookingData, setBookingData] = useState([]);
  const getBookingData = () => {
    axios
      .get("/booking")
      .then((res) => {
        console.log(res);
        setBookingData(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getBookingData();
  }, []);

  return (
    <ContextApi>
      <Layout>
        <div className="bg-gray-200 h-fit px-2 py-3  laptop:p-5">
          <div className=" laptopM:grid laptopM:grid-cols-3  ">
            <div className="col-span-2 laptopM:border-r border-gray-300 laptopM:pr-8">
              <LeftDashboardSection bookingData={bookingData} />
            </div>
            <div className="w-full h-[1px] bg-gray-300 mb-5 laptop:hidden laptop:mb-0"></div>

            <div className="col-span-1">
              <RightDashboardSection bookingData={bookingData} />
            </div>
            <div className="w-full h-[1px] bg-gray-300 mb-5 laptop:hidden laptop:mb-0"></div>
          </div>
        </div>
      </Layout>
    </ContextApi>
  );
}

export default DashBoard;
